"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var typography = {
  main: {
    base: {
      fontFamily: 'FreeSans, sans-serif',
      fontSize: 14,
      fontWeight: 500
    },
    size: {
      small: {
        fontSize: 12
      },
      medium: {},
      large: {
        fontSize: 16
      }
    },
    weight: {
      light: {
        fontWeight: 300
      },
      normal: {},
      bold: {
        fontWeight: 700
      },
      black: {
        fontWeight: 900
      }
    }
  },
  body: {
    base: {},
    size: {
      small: {},
      medium: {},
      large: {}
    },
    weight: {
      light: {},
      normal: {},
      bold: {},
      black: {}
    }
  },
  code: {
    base: {
      fontFamily: 'monospace'
    },
    size: {
      small: {},
      medium: {},
      large: {}
    },
    weight: {
      light: {},
      normal: {},
      bold: {},
      black: {}
    }
  }
};
var _default = typography;
exports["default"] = _default;